<div class="dashboard" id="dashboard">
    <!-- ========== HEADER ========== -->
    <header class="header">
        <div class="header-right">
            <button class="back-btn" routerLink="/" title="بازگشت"><i class="fa fa-arrow-right"></i></button>
            <div>
                <h1> داشبورد ایمنی ناوگان</h1>
                <div class="sub">
                    <i class="fa fa-line-chart"></i> پایش رفتار رانندگی و شناسایی خودروهای پرخطر
                </div>
            </div>
        </div>
        <div class="header-left">
            <div class="date-box">
                <span class="today">{{ todayDate }}</span>
                <span>آخرین بروزرسانی: <span>{{ lastUpdate }}</span></span>
            </div>
            <button class="btn-refresh" (click)="refresh()">
                <i class="fa fa-refresh"></i> بروزرسانی
            </button>
        </div>
    </header>
    <!-- ========== SUMMARY CARDS ========== -->
    <section class="summary-cards">
        <div class="card" [ngClass]="summaryCards[0].cls">
            <div class="card-icon"><i class="fa {{ summaryCards[0].icon }}"></i></div>
            <div class="card-title">{{ summaryCards[0].title }}</div>
            <div class="card-value">{{ summaryCards[0].value }}</div>
            <div class="card-desc"><i class="fa fa-info-circle"></i> {{ summaryCards[0].desc }}</div>
        </div>
        <div class="card" [ngClass]="summaryCards[1].cls">
            <div class="card-icon"><i class="fa {{ summaryCards[1].icon }}"></i></div>
            <div class="card-title">{{ summaryCards[1].title }}</div>
            <div class="card-value">{{ summaryCards[1].value }}</div>
            <div class="card-desc"><i class="fa fa-info-circle"></i> {{ summaryCards[1].desc }}</div>
        </div>
        <div class="card" [ngClass]="summaryCards[2].cls">
            <div class="card-icon"><i class="fa {{ summaryCards[2].icon }}"></i></div>
            <div class="card-title">{{ summaryCards[2].title }}</div>
            <div class="card-value">{{ summaryCards[2].value }}</div>
            <div class="card-desc"><i class="fa fa-info-circle"></i> {{ summaryCards[2].desc }}</div>
        </div>
        <div class="card" [ngClass]="summaryCards[3].cls">
            <div class="card-icon"><i class="fa {{ summaryCards[3].icon }}"></i></div>
            <div class="card-title">{{ summaryCards[3].title }}</div>
            <div class="card-value">{{ summaryCards[3].value }}</div>
            <div class="card-desc"><i class="fa fa-info-circle"></i> {{ summaryCards[3].desc }}</div>
        </div>
        <div class="card" [ngClass]="summaryCards[4].cls">
            <div class="card-icon"><i class="fa {{ summaryCards[4].icon }}"></i></div>
            <div class="card-title">{{ summaryCards[4].title }}</div>
            <div class="card-value">{{ summaryCards[4].value }}</div>
            <div class="card-desc"><i class="fa fa-info-circle"></i> {{ summaryCards[4].desc }}</div>
        </div>
    </section>
    <!-- ========== CHARTS ROW ========== -->
    <section class="charts-row">
        <div class="chart-container">
            <h3><i class="fa fa-pie-chart"></i> توزیع ایمنی ناوگان</h3>
            <div class="chart-wrapper">
                <canvas id="safetyDistributionChart"></canvas>
            </div>
            <div class="chart-legend">
                <span *ngFor="let item of distributionLegend">
                    <span class="dot" [style.background]="item.color"></span>
                    {{ item.label }}: <strong>{{ item.count }}</strong>
                </span>
            </div>
        </div>
        <div class="chart-container">
            <h3><i class="fa fa-bar-chart"></i> مقایسه مؤلفه‌های ایمنی (اولین خودرو)</h3>
            <div class="chart-wrapper">
                <canvas id="radarChart"></canvas>
            </div>
        </div>
    </section>
    <!-- ========== MAIN TABLE ========== -->
    <section class="table-section">
        <div class="table-header">
            <h3><i class="fa fa-table"></i> جدول خودروها</h3>
            <div class="table-controls">
                <input type="text" placeholder="جستجوی نام خودرو..." [(ngModel)]="searchTerm" (ngModelChange)="applyTableView()">
                <select [(ngModel)]="statusFilter" (ngModelChange)="applyTableView()">
                    <option value="all">همه وضعیت‌ها</option>
                    <option value="safe">ایمن (۸۰-۱۰۰)</option>
                    <option value="warning">نیازمند توجه (۶۰-۸۰)</option>
                    <option value="danger">پرخطر (۴۰-۶۰)</option>
                    <option value="critical">بسیار پرخطر (کمتر از ۴۰)</option>
                </select>
            </div>
        </div>
        <div class="table-stats">نمایش {{ visibleVehicles.length }} خودرو</div>
        <div class="table-wrapper" style="max-height:420px;overflow-y:auto;">
            <table>
                <thead>
                    <tr>
                        <th *ngFor="let col of tableColumns">{{ col.label }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr class="pointer" *ngFor="let v of visibleVehicles; trackBy: trackByUnitId" [ngClass]="getRowClass(v)" (click)="selectVehicle(v.strUnitID)">
                        <td>
                            <div>{{ vehicleName(v) }}</div>
                            <div *ngIf="v.strVehicleNo" style="color:#6f8397;font-size:0.7rem;">{{ v.strVehicleNo }}</div>
                        </td>
                        <td><span class="badge" [ngClass]="getStatus(v.SafetyIndex).badge">{{ v.SafetyIndex?.toFixed(1) }}</span></td>
                        <td><ng-container *ngIf="v.AcceleratorScore !== null && v.AcceleratorScore !== undefined; else noData">{{ v.AcceleratorScore | faNum}}</ng-container></td>
                        <td><ng-container *ngIf="v.TorqueScore !== null && v.TorqueScore !== undefined; else noData">{{ v.TorqueScore | faNum}}</ng-container></td>
                        <td><ng-container *ngIf="v.SpeedScore !== null && v.SpeedScore !== undefined; else noData">{{ v.SpeedScore | faNum}}</ng-container></td>
                        <td><ng-container *ngIf="v.StopGoScore !== null && v.StopGoScore !== undefined; else noData">{{ v.StopGoScore | faNum}}</ng-container></td>
                        <td><ng-container *ngIf="v.MaxSpeed !== null && v.MaxSpeed !== undefined; else noData">{{ v.MaxSpeed | faNum}}</ng-container></td>
                        <td>{{ v.TotalRiskEvents | faNum }}</td>
                        <td>{{ v.TotalHighEvents | faNum }}</td>
                        <td>{{ v.TotalVeryHighEvents | faNum }}</td>
                        <td>{{ v.AcceleratorEvents | faNum }}</td>
                        <td>{{ v.TorqueEvents | faNum }}</td>
                        <td style="font-size:0.7rem;direction:ltr;">{{ formatDate(v.dtSDateTime) }}</td>
                        <td style="font-size:0.7rem;direction:ltr;">{{ formatDate(v.dtEDateTime) }}</td>
                    </tr>
                    <tr *ngIf="!visibleVehicles.length">
                        <td [attr.colspan]="tableColumns.length" style="text-align:center;padding:40px;color:#6f8397;">هیچ خودرویی مطابق فیلتر یافت نشد</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </section>
    <!-- ========== BOTTOM PANELS ========== -->
    <section class="bottom-panels">
        <div class="panel">
            <h3><i class="fa fa-exclamation-triangle" style="color:#f1c40f;"></i> خودروهای نیازمند توجه</h3>
            <div class="panel-list">
                <div *ngIf="!attentionList.length" style="color:#6f8397;text-align:center;padding:20px;">هیچ خودروی نیازمند توجهی وجود ندارد</div>
                <div class="panel-item" *ngFor="let v of attentionList" (click)="selectVehicle(v.strUnitID)">
                    <span class="id">{{ vehicleName(v) }}
                        <span *ngIf="v.strVehicleNo" style="color:#8b9eb0;font-size:0.7rem;"> | {{ v.strVehicleNo }}</span>
                    </span>
                    <span class="meta">
                        <span class="safety" [style.color]="getStatus(v.SafetyIndex).color">{{ v.SafetyIndex?.toFixed(1) }}</span>
                        <span class="badge" [ngClass]="getStatus(v.SafetyIndex).badge">{{ getStatus(v.SafetyIndex).label }}</span>
                        <span class="events"><i class="fa fa-exclamation-circle"></i> {{ v.TotalRiskEvents | faNum }}</span>
                    </span>
                </div>
            </div>
        </div>
        <div class="panel">
            <h3><i class="fa fa-fire" style="color:#e74c3c;"></i> خودروهای با بیشترین رویداد پرخطر</h3>
            <div class="panel-list">
                <div *ngIf="!topRiskList.length" style="color:#6f8397;text-align:center;padding:20px;">هیچ رویداد پرخطری ثبت نشده است</div>
                <div class="panel-item" *ngFor="let v of topRiskList" (click)="selectVehicle(v.strUnitID)">
                    <span class="id">{{ vehicleName(v) }}
                        <span *ngIf="v.strVehicleNo" style="color:#8b9eb0;font-size:0.7rem;"> | {{ v.strVehicleNo }}</span>
                    </span>
                    <span class="meta">
                        <span class="events"><i class="fa fa-exclamation-circle"></i> {{ v.TotalRiskEvents | faNum }} رویداد</span>
                        <span class="badge" [ngClass]="getStatus(v.SafetyIndex).badge">{{ v.SafetyIndex?.toFixed(1) }}</span>
                    </span>
                </div>
            </div>
        </div>
    </section>
</div>

<ng-template #noData><span class="null-value">بدون داده</span></ng-template>

<app-safety-vehicle-modal></app-safety-vehicle-modal>
